const gridLayoutStyles = `
  .widget-drag-handle {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    /*
     * The handle is a whole title bar, or a whole text card, so a finger
     * landing on it must still scroll the dashboard. Panning stays with the
     * browser; a press-and-hold is what starts a touch drag, and from then
     * on the grid's touch sensor cancels the browser's moves itself. Only
     * double-tap zoom is taken away, so a quick second tap cannot zoom in.
     */
    touch-action: manipulation;
  }

  .dashboard-grid-layout {
    position: relative;
    background: transparent;
  }

  .grid-widget-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: visible;
  }

  /* The widget configuration preview is a still image of a widget. */
  .preview-widget .widget-drag-handle {
    pointer-events: none;
  }
`

export const injectGridStyles = (): void => {
  if (typeof document === "undefined") {
    return
  }

  const styleId = "dashboard-grid-styles"

  if (document.getElementById(styleId)) {
    return
  }

  const style = document.createElement("style")
  style.id = styleId
  style.textContent = gridLayoutStyles
  document.head.appendChild(style)
}
